<template>
    <h2>{{title}}</h2>
</template>

<script>
export default {
    props: ["title"]
};
</script>

<style scoped>
</style> 